OT.createNS('OT.Redesign.Views.Modals');

OT.Redesign.Views.Modals.RefineFiltersModal = Backbone.ViewManager.BaseView.extend({
    el: '#RefineFiltersModal',

    settings: {
        open: {
            opacity: 0,
            visibility: 'visible',
            display: 'block'
        },
        close: {
            opacity: 1,
            visibility: 'hidden',
            display: 'none'
        }
    },

    events: {
        'click #RefineApplyLink': 'onApplyChanges',
        'click #RefineCancelLink': 'onCancelChanges'
    },

    initialize: function () {},

    onApplyChanges: function (e) {
        e.preventDefault();
        this.close();
    },

    onCancelChanges: function (e) {
        e.preventDefault();
        this.close();
    },

    show: function () {
        this.$el
            .css(this.settings.open)
            .show()
            .css({ opacity: 1 });
    },

    close: function () {
        this.$el
            .css(this.settings.close)
            .hide()
            .css({ opacity: 0 });
    }
});
